import { render, staticRenderFns } from "./Mod.vue?vue&type=template&id=2ed2793c&scoped=true&"
import script from "./Mod.vue?vue&type=script&lang=js&"
export * from "./Mod.vue?vue&type=script&lang=js&"
import style0 from "./Mod.vue?vue&type=style&index=0&id=2ed2793c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2793c",
  null
  
)

export default component.exports